import * as Sentry from "@sentry/nextjs";
import { getErrorMessage } from "./utils";

export async function captureError(
  error: Error | unknown,
  context?: Record<string, any> & { showToast?: boolean },
): Promise<void> {
  const errorMessage = getErrorMessage(error);

  // Always capture in Sentry
  Sentry.captureException(error, {
    tags: {
      location: "client",
    },
    extra: {
      errorMessage,
      ...context,
    },
  });

  // Show toast only if requested (default: true for backward compatibility)
  const shouldShowToast = context?.showToast ?? true;

  if (typeof window !== "undefined" && shouldShowToast) {
    const { toast } = await import("sonner");
    toast.error(errorMessage || "An error occurred. Please try again.");
  }
}
